import React, { useState } from 'react';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function CalendarPicker({ handleClose, curDates, label }) {
    const today = new Date();

    const [chosenDate, setChosenDate] = useState(new Date(curDates?.s?.getUTCFullYear(), curDates?.s?.getUTCMonth(), curDates?.s?.getUTCDate()));

    const selectNewDate = (val) => {
        setChosenDate(val);
        handleClose(val);
    };
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={new Date(chosenDate)}
                onChange={(newValue) => selectNewDate(newValue)}
                sx={{
                    minWidth: '200px',
                    '& .MuiInputBase-root': { height: '36px', fontSize: 'small' },
                }}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: 'small',
                    },
                }}
            />
        </LocalizationProvider>
    );
};
